import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-server-errors',
  template: `<div *ngIf="error" class="form-errors">{{ error }}</div>`,
})
export class FormServerErrorsComponent {
  @Input() error: string;
}
